import NonPageDataTable from 'components/ui/DataTable/NonPageDataTable';
import 'css/style.css';
import React, { FC } from 'react';
import { Cell } from 'react-table';
import { useListCertificateSignatureQuery } from 'redux/reducers/signature';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import EditIcon from '../../../../assets/images/icons/edit.png';
import { ICertificateSignatureInput } from './schema';
import { backendURL } from 'redux/reducers/settings';
interface ICourseCategoryDataTable {
  tableHeaders: () => React.ReactNode;
  onEditClicked: (data: ICertificateSignatureInput) => void;
  onDeleteClicked: (data: ICertificateSignatureInput) => void;
}
const CertificateSignatureTable: FC<ICourseCategoryDataTable> = ({
  tableHeaders,
  onEditClicked,
  onDeleteClicked
}) => {
  const { data: courseCategoryData, isLoading } = useListCertificateSignatureQuery();

  const columns: any = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (data: Cell<ICertificateSignatureInput>) => {
        return <>{data.row.index + 1}</>;
      }
    },
    {
      Header: 'Name',
      accessor: 'full_name'
    },
    {
      Header: 'Position',
      accessor: 'position'
    },

    {
      Header: 'Signature',
      Cell: (data: Cell<ICertificateSignatureInput>) => {
        return (
          <>
            <img
              width={70}
              height={30}
              src={backendURL + data.row.original?.signature}
              className="icons"
            />
          </>
        );
      }
    },
    {
      Header: '  Action',
      Cell: (data: Cell<ICertificateSignatureInput>) => {
        return (
          <>
            <img
              src={EditIcon}
              className="icons"
              onClick={() => onEditClicked(data.row.original)}
            />
            <img
              src={DeleteIcon}
              className="m-2 icons"
              onClick={() => onDeleteClicked(data.row.original)}
            />
          </>
        );
      }
    }
  ];
  return (
    <div>
      <NonPageDataTable
        columns={columns}
        data={courseCategoryData?.data || []}
        tableHeaders={tableHeaders}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CertificateSignatureTable;
